module.exports = __webpack_public_path__ + "img/bar-bill-active.46b781e3.svg";